import type { PartnerSummaryResponse } from '../../repositories';

export class PartnerSummary {
  constructor(private apiResponse: PartnerSummaryResponse) {}

  public getPartnerUID(): number {
    return this.apiResponse.partnerUID;
  }

  public getIsExternalPartner(): boolean {
    return this.getPartnerUID() !== -1;
  }

  public getPartnerInquiryUID(): number {
    return this.apiResponse.partnerInquiryUID;
  }

  public getParentPartnerUID(): number {
    return this.apiResponse.parentPartnerUID;
  }

  public getPartnerName(): string {
    return this.apiResponse.partnerName;
  }

  public getPartnerType(): string {
    return this.apiResponse.partnerType;
  }

  public getPartnerTypeString(): string {
    return this.apiResponse.partnerTypeString;
  }

  public getPartnerLevel(): string {
    return this.apiResponse.partnerLevel;
  }

  public getPartnerLevelString(): string {
    return this.apiResponse.partnerLevelString;
  }

  public getPartnerStatus(): string {
    return this.apiResponse.partnerStatus;
  }

  public getPartnerStatusString(): string {
    return this.apiResponse.partnerStatusString;
  }

  public getPartnerSiteURL(): string {
    return this.apiResponse.partnerSiteURL;
  }

  public getPartnerPhoneNumber(): string {
    return this.apiResponse.partnerPhoneNumber;
  }

  public getPartnerContactEmail(): string {
    return this.apiResponse.partnerContactEmail;
  }

  public getPartnerContactName(): string {
    return this.apiResponse.partnercontactName;
  }

  public getSoLoginUID(): number {
    return this.apiResponse.soLoginUID;
  }

  public getBillingType(): string {
    return this.apiResponse.billingType;
  }

  public getCompanyName(): string {
    return this.apiResponse.companyName;
  }

  public getCreationDate(): string {
    return this.apiResponse.creationDate;
  }

  public getPartnerCurrency(): string {
    return this.apiResponse.partnerCurrency;
  }

  static fromSchema(data: {
    partnerUID: number;
    partnerInquiryUID: number;
    parentPartnerUID: number;
    partnerName: string;
    partnerType: string;
    partnerTypeString: string;
    partnerLevel: string;
    partnerLevelString: string;
    partnerStatus: string;
    partnerStatusString: string;
    partnerSiteURL: string;
    partnerPhoneNumber: string;
    partnerContactEmail: string;
    partnercontactName: string;
    soLoginUID: number;
    billingType: string;
    companyName: string;
    creationDate: string;
    partnerCurrency: string;
  }): PartnerSummary {
    return new PartnerSummary(data as PartnerSummaryResponse);
  }
}
